import { Injectable } from '@angular/core';
import { BaseProvider } from '../../shared/providers/base-provider';
import { BasemapNotifier } from '../notifiers/basemap-notifier';
import { BasemapState } from '../states/basemap-state';

@Injectable({ providedIn: 'root' })
export class BasemapProvider extends BaseProvider<BasemapNotifier, BasemapState> {
  constructor() {
    super(BasemapNotifier);
  }
}
